/**
 *
 * UserPagesRedirect
 *
 */
import * as React from 'react';
import { match, useHistory, useParams } from 'react-router-dom';
import { TabKeys } from '../Tabs/constants';
import { UserDetailPage } from 'app/pages/UserDetailPage';
import { UserPortfoliosPage } from 'app/pages/UserPortfoliosPage/Loadable';
import { useInitializeTab } from 'app/helpers/InitializeTab';
import {
  UserDetailPageManager,
  useUserDetailPageSlice,
} from 'app/pages/UserDetailPage/slice';
import {
  SubscriptionDetailPageManager,
  useSubscriptionDetailPageSlice,
} from 'app/pages/SubscriptionDetailPage/slice';
import { useDispatch, useSelector } from 'react-redux';
import { useInitializeSiteTitleWithSuffix } from 'app/helpers/InitializeSiteTitle';
import { selectUserDetailPage } from 'app/pages/UserDetailPage/slice/selectors';
import { withManagers } from 'utils/withManagers';

export const UserPagesRouter = () => {
  const { id, tab } = useParams<{ id: string; tab: string }>();
  const history = useHistory();
  const dispatch = useDispatch();
  const { user } = useSelector(selectUserDetailPage);

  const {
    actions: { fetchUserDetail, cleanup: cleanupUser },
  } = useUserDetailPageSlice();

  const {
    actions: { cleanup: cleanupSub },
  } = useSubscriptionDetailPageSlice();

  React.useEffect(() => {
    dispatch(fetchUserDetail(id));
    dispatch(cleanupSub());

    return () => {
      dispatch(cleanupUser());
    };
  }, [id, dispatch, fetchUserDetail, cleanupSub, cleanupUser]);

  useInitializeTab(id, 'user');
  useInitializeSiteTitleWithSuffix('User', user?.email);

  switch (tab) {
    case TabKeys.user['user-detail'].urlByTab:
      return <UserDetailPage />;
    case TabKeys.user.portfolios.urlByTab:
      return <UserPortfoliosPage />;
    default:
      history.replace('/');
      return null;
  }
};

export default withManagers(
  UserDetailPageManager,
  SubscriptionDetailPageManager,
)(UserPagesRouter);
